module.exports = __webpack_public_path__ + "img/undraw_server_down.14f40df8.svg";